import { useLang } from 'hooks/lang';

import { invoiceControlConfigByCode } from 'entities';

import { Button, Dot, DropdownMenu, DropdownMenuItem } from 'components/Blocks';

interface StatusSelectProps {
  children?: never;
  status: string;
}

export function StatusSelect({ status }: StatusSelectProps) {
  const { t } = useLang();

  const config = invoiceControlConfigByCode[status];

  return (
    <DropdownMenu
      align="start"
      trigger={
        <Button variant="ghost" tooltipContent="Status">
          <Dot color={config.color} />
          {config.getLabel(t)}
        </Button>
      }
    >
      {Object.values(invoiceControlConfigByCode).map(({ code, color, getLabel, routeId }) => (
        <DropdownMenuItem
          key={code}
          to="invoiceProjectsByStatus"
          params={{ status: routeId }}
          className={code === status ? 'text-primary focus:text-primary' : ''}
        >
          <Dot color={color} />
          {getLabel(t)}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
}
